import { Note } from '@card-software/library';
import { AuditTrail } from '@card-software/nexus-models';
import { Fabric } from '../fabric/fabric';

export enum PackingType {
  Rolling,
  Folding,
}

export enum WorkOrderType {
  Sample = 0,
  Bulk = 1,
  GreigeStockForDyeing = 2,
  ShortFall = 3,
  Linked = 4,
  BGrade = 5,
  GreigeOnly = 6,
}

export interface WorkOrder extends AuditTrail {
  id: string;
  orderReceivedDate?: string;
  orderNumber?: string;
  status: number;
  orderType: number;
  workOrderTerm: number;
  customerReference?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customer?: any;
  brandReference?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  brand?: any;
  shippingToReference?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  shippingTo?: any;
  shippingAddressCode?: number;
  billingToReference?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  billingTo?: any;
  billingAddressCode?: number;
  shipmentType?: number;
  actualShipmentDate?: string;
  uom: number;
  notes?: Note[];
  fabrics: WorkOrderFabric[];
  programReference?: string;
  customerProductOrders: CustomerProductOrder[];
  planningEstimatedYW?: YearWeek;
  estimatedShipmentDate?: string;
  negotiatiedLeadTimeInWeeks?: number;
  specificWorkOrderGreigeReference?: string;
  estimatedDatesPlanning?: EstimatedDatesPlanning;
  totalQuantities?: WorkOrderTotalQuantities;
  promisedShipmentDate?: string;
  yarnOrigin?: number;
  parentBulkWorkOrder?: string;
}

export interface WorkOrderTotalQuantities {
  totalEstimatedPlanningQuantity?: number;
  totalActualPlannedQuantity?: number;
  totalBatchingIssuedQuantity?: number;
  totalEstimatedKnittingQuantity?: number;
  totalPlannedKnittingQuantity?: number;
  totalActualKnittingQuantity?: number;
  totalKnittingIssuedQuantity?: number;
  totalKnittingProgrammedQuantity?: number;
}

export interface WorkOrderFabricQuantities {
  estimatedPlanningQuantity?: number;
  actualPlannedQuantity?: number;
  batchingIssuedQuantity?: number;
  estimatedKnittingQuantity?: number;
  plannedKnittingQuantity?: number;
  actualKnittingQuantity?: number;
  knittingIssuedQuantity?: number;
  knittingProgrammedQuantity?: number;
}

export interface WorkOrderFabric {
  fabricCode: string;
  fabric?: Fabric;
  productOrderNumber?: string;
  packingType: number;
  quantityInUOM: number;
  quantityInPounds: number;
  quantityInYards: number;
  quantities?: WorkOrderFabricQuantities;
  unitPrice?: number;
  aliasReference?: string;
  certificationReference?: string;
  garmetPart: number;
  garmetDetails: GarmetDetails[];
  yarnCertificationDetails?: YarnCertificationDetails[];
}

export interface GarmetDetailsQuantities {
  estimatedPlanningQuantity?: number;
  actualPlannedQuantity?: number;
  batchingIssuedQuantity?: number;
}

export interface GarmetDetails {
  colorReference?: string;
  quantity: number;
  quantityInPounds: number;
  productOrderNumber?: string;
  quantities?: GarmetDetailsQuantities;
}

export interface CustomerProductOrder {
  productOrderNumber?: string;
  clientOrderReference?: string;
  dateReceived?: string;
}

export interface YarnCertificationDetails {
  yarnCode?: string;
  certificationReferences?: string[];
}

export interface YearWeek {
  year: number;
  week: number;
}

export interface EstimatedDatesPlanning {
  knittingLatestStartDate?: string;
  knittingEstimatedEndDate?: string;
  dyeingLatestStartDate?: string;
  dyeingEstimatedEndDate?: string;
  finishingLatestStartDate?: string;
  finishingEstimatedEndDate?: string;
  yarnLatestReceptionDate?: string;
}

export interface WorkOrderSearchCommand {
  orderNumber?: string;
  customerReference?: string;
  brandReference?: string;
  orderType?: number;
  customerProductOrder?: string;
  statuses?: number[];
}
